import React, { useState } from 'react'
import { GET_SCREENS_INDEX, TOTAL_SCREENS } from '../../../utilities/commonUtils'
import ScrollService from '../../../utilities/ScrollService'
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Header.css'

const Header = () => {
    const [selectedScreen, setselectedScreen] = useState(0);
    const [headerOpt, setHeaderOptions] = useState(false);

    const updateCurrScreen = (currScreen) => {
        if (!currScreen || !currScreen.screenInView) return;
        let screenIdx = GET_SCREENS_INDEX(currScreen.screenInView);
        if (screenIdx < 0) return;
    }
        let currScreenSub =
            ScrollService.currScreenBroCaster.subscribe(updateCurrScreen);

        const getHeaderOptions = () => {
            return( TOTAL_SCREENS.map((screen, i) => (
                <div
                    key={screen.screen_name}
                    className={getHeaderOptClass(i)}
                    onClick={() => switchScreen(i, screen)}
                >
                    <span>{screen.screen_name}</span>
                </div>
            )))
        };

        const getHeaderOptClass = (index) => {
            let classes = "header-option";
            if (index < TOTAL_SCREENS.length)
                classes += "header-option-seperator";

            if (selectedScreen === index) classes += "selected-header-option";
            return;
        };

        const switchScreen = (index, screen) => {
            let srceenComponent = document.getElementById(screen.screen_name);
            if (!srceenComponent) return;

            srceenComponent.scrollIntoView({ behavior: "smooth" });
            setselectedScreen(index);
            setHeaderOptions(false);
        };

    return (
        <div>
            <div className="hCont" onClick={() => setHeaderOptions(!headerOpt)}>
                <div className="hParent">
                    <div className="hHam" onClick={() => setHeaderOptions(!headerOpt)}>
                        <FontAwesomeIcon className="header-hamburger-bars" icon={faBars} />
                    </div>
                    <div className="hLogo">
                        <span>Gaurav ~</span>
                    </div>
                    <div
                        className={(headerOpt) ? "header-options show-hamburger-options" : "header-options"}>
                            {getHeaderOptions()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header